<template>
    <div>
        <div v-if="documentData" class="proofreading-actions-container">
            <el-card>
                <div class="panel-title">{{ $t('proofreading.panelTitle') }}</div>
                <ProofreadingActions :document="documentData" />
            </el-card>
        </div>
        <div class="proofreading-actions-container">
            <el-card>
                <div class="panel-title">{{ $t('proofreadingInstructions.postProofreadingInstructionsTitle') }}</div>
                <PostProofreadingInstructions />
            </el-card>
        </div>
        <div class="configuration-container">
            <TranslationConfig :modelValue="translationConfig"
                               :view-mode="true"
                               :documentType="documentType"
                               :pageNamePrefix="$t('archive.configurationPrefix')" />
        </div>
        <SegmentListPreview :scroll-on-load="false" />
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { DocumentType } from '@/models/DocumentType';
    import { Document } from '@/models/Document';

    import TranslationConfig from '@/features/TranslationConfig/TranslationConfig.vue';
    import SegmentListPreview from '@/pages/Archive/SegmentListPreview.vue';
    import ProofreadingActions from './ProofreadingActions.vue';
    import PostProofreadingInstructions from './PostProofreadingInstructions.vue';

    import { proofreadingDocumentService } from './proofreadingDocumentService';

    export default defineComponent({
        components: {
            TranslationConfig,
            SegmentListPreview,
            ProofreadingActions,
            PostProofreadingInstructions,
        },
        data() {
            return {
                documentData: null as Document | null,
                translationConfig: null,
                service: new proofreadingDocumentService(),
            };
        },
        mounted() {
            this.loadDocConfigurations();
        },
        computed: {
            documentId(): number {
                return Number(this.$route.params.id);
            },
            documentType(): DocumentType {
                return this.documentData != null
                    ? this.documentData.documentType
                    : DocumentType.Docx;
            },
        },
        methods: {
            async loadDocConfigurations() {
                this.documentData = await this.service.loadConfigurations(this.documentId);
                this.translationConfig = this.documentData?.translationConfig ?? null;
            },
        },
    });
</script>

<style lang="scss" scoped>
    .panel-title {
        font-weight: bold;
        font-size: 16px;
    }

    .proofreading-actions-container {
        margin-bottom: 20px;
    }

    .configuration-container {
        margin-bottom: 40px;
    }
</style>
